export function pageFromNextLink(nextLink: unknown): string | undefined {
  if (typeof nextLink !== 'string' || !nextLink.includes('?')) return undefined;
  return new URLSearchParams(nextLink.split('?')[1]).get('page') ?? undefined;
}
